import React from 'react';

const SvgTn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="TN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="TN_svg__b" fill="#fff">
        <use xlinkHref="#TN_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#TN_svg__a" />
      <path fill="#E92434" mask="url(#TN_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M15.811 5.698a4.667 4.667 0 1 0 0 8.604 4.334 4.334 0 0 1 0-8.604zM14 16a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm2.354-4.83l1.803.674-1.033-1.624 1.197-1.507-1.863.482-1.063-1.605-.118 1.921-1.855.515 1.79.706-.083 1.923 1.225-1.485z"
        fill="#FFF"
        mask="url(#TN_svg__b)"
      />
    </g>
  </svg>
);

export default SvgTn;
